var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "22px",
    viewBox: "0 0 24 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "back") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Deep-Dive---Nondisclosure-and-Expunction",
    transform: "translate(-83.000000, -64.000000)",
    fill: "#959280"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.0576006,64.6420675 C91.7913731,63.8382477 93.037838,63.7814632 93.8416578,64.5152357 C94.6580868,65.2605187 94.723273,66.5238195 93.9878888,67.349176 L93.9878888,67.349176 L89.222,72.698 L104.408691,72.6198326 C105.491579,72.6142581 106.373951,73.4875927 106.379526,74.5704801 L106.379507,74.5937529 L106.379507,74.5937529 C106.372116,75.693349 105.481624,76.5824408 104.382018,76.5881014 L89.136,76.666 L93.9878888,82.1110923 C94.723273,82.9364487 94.6580868,84.1997495 93.8416578,84.9450325 C93.037838,85.678805 91.7913731,85.6220205 91.0576006,84.8182007 L91.0416859,84.8005542 L91.0416859,84.8005542 L83.5115935,76.349176 C83.1026727,75.8902249 82.9412942,75.2958583 83.0189765,74.7304433 C82.9411045,74.1651089 83.1024323,73.5703131 83.5115935,73.1110923 L83.5115935,73.1110923 L91.0416859,64.659714 C91.0469553,64.6537999 91.0522603,64.6479177 91.0576006,64.6420675 Z",
    id: "back"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.58848d2f5f304787dc83efc9963c0c72.svg";
export { ForwardRef as ReactComponent };